import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfigurationService, IAppSettings } from '../../services/configuration/configuration.service';

export interface ConcurrentUser {
  userName: string;
  canEditResource: boolean;
}

@Injectable({ providedIn: 'root' })
export class ConcurrentAccessService {
  private userName: string;
  public visibility: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public userCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public concurrentUsers: BehaviorSubject<ConcurrentUser[]> = new BehaviorSubject<ConcurrentUser[]>([]);

  constructor(private configurationService: ConfigurationService<IAppSettings>) {
    this.configurationService
      .get('UserName')
      .pipe(
        tap(user => {
          this.userName = user;
        })
      )
      .subscribe();
  }

  public setUserCount(concurrentUsers: ConcurrentUser[]): void {
    const count = concurrentUsers.filter(x => x.userName !== this.userName).length;
    this.visibility.next(count !== 0);
    this.userCount.next(count);
    this.concurrentUsers.next(concurrentUsers);
  }
}
